export const enLanguageSelectorTranslations = {
    LANGUAGE_SELECTOR__TITLE: 'Change language',
    LANGUAGE_SELECTOR__MOBILE__TITLE: 'Choose language',
    LANGUAGE_SELECTOR__MOBILE__DESCRIPTION: 'Personal account interface language:',
};
